export default __webpack_public_path__ + "18288e8c7a4c3ff27ae5b06634f8e8ae.png";